import(/* webpackMode: "eager", webpackExports: ["CTACard"] */ "/app/components/cta/cta-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GrammarHanzi"] */ "/app/components/grammar/grammar-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hanzi"] */ "/app/components/hanzi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdiomDetailClient"] */ "/app/components/idioms/idiom-detail-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdiomNavigation"] */ "/app/components/idioms/idiom-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicNavbar"] */ "/app/components/layout/public-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MoyuCTA"] */ "/app/components/moyu/moyu-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
